import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'DOSSIER',
  title: 'Wie ist der Ordner aufgebaut?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Ihre Dokumente sind in mehrere Unterordner unterteilt:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Standard: Hier finden Sie die obligatorischen Dokumente, die das Legal Unterordner bilden'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_DOSSIER/DE_DOSSIER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Geschäftsbereich: hier finden Sie alle anderen Dokumente, die sich auf Ihren Tätigkeitsbereich im Rahmen eines Nachunternehmers beziehen'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_DOSSIER/DE_DOSSIER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Zusätzlich: hier finden Sie zusätzliche Dokumente zu Ihrem Ordner'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_DOSSIER/DE_DOSSIER_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Projekte: hier finden Sie alle Dokumente, die mit einem Projekt zusammenhängen'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_DOSSIER/DE_DOSSIER_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'In jedem Dokument finden Sie den Status des Dokuments.'
  }]
};
